<template>
  <div class="list-container">
    <el-card class="list-card" :body-style="{ padding: '0px' }">
      <div class="list-card-left">
        <div class="stack-card-left-header" v-if="userInfo.roleValue === 1">
          <div class="stack-card-left-header-title">
            <h4>{{ $t('content.books.area_lang') }}</h4>
            <el-select
              v-model="value"
              :placeholder="$t('placeholder.select')"
              value-key="value"
              @change="chooseMedicine(value)"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="sideBar-node" v-bar>
          <div class="sideBar-node-wrap">
            <ul
              class="sideBar-tree"
              v-for="(node, index) in channels"
              :key="index"
            >
              <sideBar
                :node="node"
                :index="index"
                :depth="0"
                :dragCtrl="dragCtrl"
                @treeNodeClick="treeNodeClick"
                @editorNode="editorNode"
                @addChildNode="addChildNode"
                @refreshNode="refreshNode"
                @delNode="delNode"
                @dragstart="dragstart"
                @drop="drop"
                @changeTreeNodeChild="changeTreeNodeChild"
              />
            </ul>
          </div>
        </div>
        <div class="sideBar-tree-btn">
          <button class="global-button-style" @click="addRootNode">
            <i class="el-icon-plus"></i>
          </button>
        </div>
      </div>
      <div class="list-card-right">
        <bookListHeader
          :bookInfo="bookInfo"
          :ancestorts="ancestorts"
          @editBookList="editBookList"
          @publish="publish"
          @timing="timing"
          @addBook="addBook"
          @manageBook="manageBook"
          @importBook="importBook"
          :selectCtrl="isSelect"
        />
        <div class="stack-mgt-handle">
          <p>
            {{ $t('content.books.records') }}：{{
              bookInfo ? bookInfo.booksTotal : 0
            }}
          </p>
          <div class="stack-mgt-search">
            <i @click="model = !model" v-show="!isSelect">
              <img src="@/assets/img/table.png" alt="" v-show="!model" />
              <img src="@/assets/img/unorderedList.png" alt="" v-show="model" />
            </i>
            <list-search
              ref="listSearch"
              @listSearchEvn="listSearchEvn"
              @clearSearch="clearSearch"
            />
            <div v-if="isSelect">
              <button class="global-button-style" @click="batchAdd">
                {{ $t('content.books.addToGroup') }}
              </button>
              <button class="global-button-style" @click="batchDel">
                {{ $t('commonMsg.remove') }}
              </button>
              <button
                class="global-button-style"
                @click.stop="setPriceForBooks"
              >
                {{ $t('content.books.setPrice') }}
              </button>
              <button class="global-button-style" @click="done">
                {{ $t('commonMsg.cancel') }}
              </button>
            </div>
          </div>
        </div>
        <div class="stack-card-item" v-if="model">
          <div class="stack-card-sort">
            <div class="sort-item">
              <span
                v-for="(target, id) in tagListBtn"
                :key="id"
                @click="choseprofromBtn(id)"
                :class="{ secectBackground: flagBtn == id }"
              >
                {{ target.name }}
              </span>
            </div>
            <div class="sort-item">
              <el-checkbox
                v-if="isSelect"
                v-model="allCheck"
                :label="$t('commonMsg.checkAll')"
                @change="checkAll"
              ></el-checkbox>
              <span
                v-for="(target, id) in tagList"
                :key="id"
                @click="choseprofrom(id)"
                :class="{ secectBackground: flag == id }"
              >
                {{ target.name }}
              </span>
            </div>
          </div>
          <BookRightItem
            component="stack"
            :booksData="booksData"
            :manage="manage"
            @checkBookDetail="checkBookDetail"
            @delEvn="delEvn"
            @moveEvn="moveEvn"
            :selectCtrl="isSelect"
            @selectEvn="selectEvn"
          />
        </div>
        <div class="stack-card-item" v-else>
          <BooksTableItem
            ref="BooksTable"
            :tableData="booksData"
            :tableProps="tableProps"
            :selectCtrl="isSelect"
            :isHandle="isHandle"
            @selectEvnTable="selectEvnTable"
            @checkBookDetail="checkBookDetail"
            @delEvn="delEvn"
            @filterEvn="filterEvn"
            @moveEvn="moveEvn"
            @selectEvn="selectEvn"
            @tableHandle="tableHandle"
          />
        </div>
        <pagination
          :pageSize="params.limit"
          :total="total"
          @pageNum="getPageNum"
        />
      </div>
    </el-card>
    <transition-group name="fade">
      <pushChannel
        key="pushChannel"
        :channelData="channels"
        :ancestorts="ancestorts"
        v-if="showPushChannel"
      />
      <dateTimePicker
        key="dateTimePicker"
        v-if="showDateTimePicker"
        @pushConfirm="pushConfirm"
      />
      <addBookList
        key="addBookList"
        :channles="channels"
        @confirmEvn="confirmEvn"
        v-if="showAddBookList"
      />
      <DelPopup key="delPopup" v-if="delPopup" @deleteHandle="deleteHandle" />

      <!-- 创建/编辑频道 -->
      <addRootNodeComponent
        key="addComponent"
        v-if="addRootNodeBooks"
        :title="channelTitle"
        :channel="treeItem"
        @createChannels="createChannels"
        @editChanndls="editChanndls"
      />

      <!-- 加入/编辑书单 -->
      <addBooksList
        key="addBooksList"
        v-if="showAddBooksList"
        :bookInfo="bookInfo"
        :channel="treeItem"
        :title="addPopupTitle"
        :ruleForm="ruleForm"
        :ruleProps="ruleProps"
        :rules="rules"
        @editBookListEvn="editModules"
        @createBookListEvn="createModules"
      />

      <!-- 更新书单 -->
      <refreshBooksList
        key="refreshBooksList"
        v-if="showRefreshBooksList"
        :bookInfo="bookInfo"
        :channel="treeItem"
        :title="refreshTitle"
        :ruleForm="ruleForm"
        :ruleProps="ruleProps"
        :rules="rules"
        @refreshModules="refreshModules"
      />
    </transition-group>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import addRootNodeComponent from '@/components/addRootNodeBooks'
import pushChannel from '@/components/pushChannel'
import sideBar from '@/components/sideBar'
import bookListHeader from '../components/bookListHeader'
import BookRightItem from '../components/bookRightItem'
import pagination from '@/components/pagination'
import listSearch from '@/components/listSearch'
import dateTimePicker from '@/components/dateTimePicker'
import addBookList from '@/components/addBookList'
import DelPopup from '@/components/delPopup'
import BooksTableItem from './booksTableItem'
import addBooksList from './addBooksList'
import refreshBooksList from './refreshBooksList'

export default {
  computed: {
    ...mapGetters([
      'channels',
      'addRootNodeBooks',
      'showPushChannel',
      'showDateTimePicker',
      'showAddBookList',
      'delPopup',
      'showAddBooksList',
      'showRefreshBooksList',
      'userInfo'
    ]),
    tableProps() {
      let tableProps = [
        {
          prop: 'id',
          label: 'ID'
        },
        {
          prop: 'cover',
          label: this.$t('content.books.cover')
        },
        {
          prop: 'name',
          label: this.$t('content.books.bookName')
        },
        {
          prop: 'price',
          label: this.$t('content.books.price')
        },
        {
          prop: 'updated_at',
          label: this.$t('commonMsg.updatedAt')
        },
        {
          prop: 'status',
          label: this.$t('content.books.status')
        },
        {
          prop: 'move',
          label: this.$t('commonMsg.sort'),
          width: 200
        },
        {
          prop: 'handle',
          label: this.$t('commonMsg.handle'),
          width: 100,
          btn: [this.$t('commonMsg.check')]
        }
      ]
      return tableProps
    },
    options() {
      let options = [
        {
          value: '',
          label: this.$t('content.books.all')
        },
        {
          value: 'zh',
          label: this.$t('content.books.cn')
        },
        {
          value: 'tw',
          label: this.$t('content.books.tc')
        },
        {
          value: 'en',
          label: this.$t('content.books.en')
        }
      ]
      return options
    },
    ruleProps() {
      let ruleProps = [
        {
          prop: 'name',
          label: this.$t('content.books.groupName'),
          placeholder: this.$t('placeholder.name')
        }
      ]
      return ruleProps
    },
    rules() {
      let rules = {
        name: [
          {
            required: true,
            message: this.$t('verify.groupName'),
            trigger: 'blur'
          }
        ]
      }
      return rules
    },
    tagList() {
      let tagList = [
        { name: this.$t('content.books.inspirational'), id: 1 },
        { name: this.$t('content.books.literature'), id: 2 },
        { name: this.$t('content.books.technology'), id: 3 },
        { name: this.$t('content.books.biography'), id: 4 }
      ]
      return tagList
    },
    tagListBtn() {
      let tagListBtn = [
        { name: this.$t('content.books.all'), id: 1 },
        { name: this.$t('content.books.classify'), id: 2 },
        { name: this.$t('content.books.price'), id: 3 },
        { name: this.$t('content.books.score'), id: 4 }
      ]
      return tagListBtn
    }
  },
  components: {
    sideBar,
    addRootNodeComponent,
    bookListHeader,
    BookRightItem,
    pushChannel,
    pagination,
    listSearch,
    dateTimePicker,
    addBookList,
    DelPopup,
    BooksTableItem,
    addBooksList,
    refreshBooksList
  },
  data() {
    return {
      dragItem: null,
      dragCtrl: true,
      value: '',
      dragType: '',
      params: {
        limit: 40,
        offset: 0
      },
      addPopupTitle: '',
      refreshTitle: '',
      total: 0,
      allCheck: false,
      manage: false,
      isSelect: false,
      model: false,
      treeItem: null,
      bookInfo: {},
      booksData: [],
      bookArr: [],
      bookArrId: [],
      singleBookId: [],
      singleItem: {},
      ancestorts: [],
      channelTitle: '',
      ruleForm: {
        name: '',
        channelId: '',
        orgIds: [],
        cover: '',
        lang: '',
        id: ''
      },
      selectDatas: [],
      delType: 'single',
      flag: -1,
      flagBtn: 0,
      isHandle: 'move'
    }
  },
  methods: {
    async chooseMedicine(value) {
      this.lang = value
      await this.getBookChannels()
      if (this.channels.length && this.channels[0].children.length) {
        this.$router.push({
          path: this.$route.fullPath,
          query: { id: this.channels[0].children[0].id }
        })
      } else {
        this.$route.query.id ? this.$router.push({ name: 'list' }) : ''
        this.bookInfo = {}
        this.booksData = []
      }
    },

    getBookChannels() {
      return new Promise(async (resolve, reject) => {
        await this.$store.dispatch('getBookChannels', this.lang)
        resolve('ok')
      })
    },
    delChannels() {
      this.$http
        .delChannels(this.treeItem.id)
        .then(async (res) => {
          this.elMsg(this.$t('alertMsg.delSuccess'), 'success')
          let ids = this.treeItem.hasOwnProperty('children')
            ? this.treeItem.children.map((item) => item.id)
            : []
          if (
            this.treeItem.id === Number(this.$route.query.id) ||
            ids.includes(Number(this.$route.query.id))
          ) {
            this.$router.push({ name: 'list' })
            this.bookInfo = {}
            this.booksData = []
          }
          await this.getBookChannels()
        })
        .catch((err) => {
          //                    this.elMsg('删除失败', 'error')
        })
    },
    checkedRouteID() {
      if (!this.channels.length) return
      if (!this.$route.query.id) {
        this.channels[0].children.length
          ? this.$router.push({
              path: this.$route.fullPath,
              query: { id: this.channels[0].children[0].id }
            })
          : ''
      } else {
        this.getModulesDetail()
      }
    },
    getModulesDetail() {
      this.$http
        .getModulesDetail(this.$route.query.id, this.params)
        .then((res) => {
          this.checkOptions(res.data)
          this.ancestorts = res.data.ancestorts.map((item) => item.name)
          this.bookInfo = res.data
        })
    },
    moduleDelBooks(id) {
      return new Promise((resolve, reject) => {
        let obj = {
          ids: this.bookArrId.length ? this.bookArrId : this.selectDatas
        }
        this.$http
          .moduleDelBooks(id, obj)
          .then((res) => {
            this.elMsg(this.$t('alertMsg.delSuccess'), 'success')
            this.getModulesDetail()
            this.clearCheckOpts()
            this.done()
            resolve('')
          })
          .catch((err) => {
            //                    this.elMsg('删除失败', 'error')
          })
      })
    },

    // 创建频道
    createChannels(form) {
      this.$http
        .createChannels(form)
        .then((res) => {
          this.getBookChannels()
          this.elMsg(this.$t('alertMsg.addSuccess'), 'success')
          this.$store.commit('windowHandle')
        })
        .catch((err) => {
          this.elMsg(this.$t('alertMsg.addFailure'), 'error')
          this.$store.commit('windowHandle')
        })
    },

    // 编辑频道
    editChanndls(form) {
      this.$http
        .editModules(form.id, form)
        .then((res) => {
          this.getBookChannels()
          this.elMsg(this.$t('alertMsg.saveSuccess'), 'success')
          this.$store.commit('windowHandle')
        })
        .catch((err) => {
          this.elMsg(this.$t('alertMsg.saveFailure'), 'error')
          this.$store.commit('windowHandle')
        })
    },

    // createBookList(data){
    //      this.createModules(data)
    // },
    // editBookListEvn(data){
    //     // data.channelId=this.editorId
    //     this.editModules(data)
    // },

    // 创建频道书单
    createModules(data) {
      this.$http.createModules(data).then(async (res) => {
        this.elMsg(this.$t('alertMsg.releaseSuccess'), 'success')
        // this.$store.commit('windowHandle')
        await this.getBookChannels()
        // this.getModulesDetail();
      })
    },

    // 编辑频道书单
    editModules(data) {
      this.$http.editModules(this.bookInfo.id, data).then(async (res) => {
        await this.getBookChannels()
        this.getModulesDetail()
      })
    },
    // 更新频道书单
    refreshModules(data) {
      this.$http.refreshModules(this.bookInfo.id, data).then(async (res) => {
        await this.getBookChannels()
        this.getModulesDetail()
      })
    },
    pushConfirm(ids) {
      this.$http
        .listTochannel(this.$route.query.id, { ids: ids })
        .then((res) => {
          this.getBookChannels()
          this.elMsg(this.$t('alertMsg.releaseSuccess'), 'success')
        })
        .catch((err) => {
          this.elMsg(this.$t('alertMsg.releaseFailure'), 'error')
        })
    },
    confirmEvn(group) {
      this.moduleAddBooks(group.id)
    },
    async moduleAddBooks(id) {
      let obj = {
        ids: this.bookArrId.length ? this.bookArrId : this.selectDatas
      }
      try {
        await this.$http.moduleAddBooks(id, obj)
        this.elMsg(this.$t('alertMsg.addSuccess'), 'success')
        this.done()
      } catch (error) {
        this.elMsg(this.$t('alertMsg.addFailure'), 'error')
      }
    },

    async setPriceForBooks() {
      this.getArrID()
      if (!this.bookArrId.length && !this.selectDatas.length) {
        this.elMsg(this.$t('alertMsg.checkBook'), 'warning')
        return
      }
      try {
        let res = await this.$prompt('', this.$t('content.books.setPrice'), {
          confirmButtonText: this.$t('commonMsg.confirm'),
          cancelButtonText: this.$t('commonMsg.cancel'),
          inputPattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/,
          inputErrorMessage: this.$t('verify.num')
        })
        await this.$http.setBooksPrice({
          ids: this.bookArrId.length ? this.bookArrId : this.selectDatas,
          price: res.value
        })
        this.getModulesDetail()
        this.clearCheckOpts()
        this.done()
        this.elMsg(this.$t('alertMsg.modifySuccess'), 'success')
      } catch (error) {}
    },
    selectEvnTable(val) {
      this.selectDatas = val
    },
    batchAdd() {
      this.getArrID()
      if (!this.bookArrId.length && !this.selectDatas.length) {
        this.elMsg(this.$t('alertMsg.checkBook'), 'warning')
        return
      }
      this.$store.commit('windowHandle', 'showAddBookList')
    },
    batchDel() {
      this.getArrID()
      if (!this.bookArrId.length && !this.selectDatas.length) {
        this.elMsg(this.$t('alertMsg.checkBook'), 'warning')
        return
      }
      this.delType = 'batch'
      this.$store.commit('windowHandle', 'delPopup')
    },
    deleteHandle() {
      if (this.delType === 'batch') {
        this.bookArr = []
        this.moduleDelBooks(this.$route.query.id)
      } else if (this.delType === 'single') {
        this.singleBookId = []
        this.singleBookId.push(this.singleItem.id)
        let idx = this.bookArr.indexOf(this.singleItem)
        this.bookArr.splice(idx, 1)
        this.moduleDelBooks(this.$route.query.id)
      } else if (this.delType === 'treeNode') {
        this.delChannels()
      }
    },
    getPageNum(val) {
      this.params.offset = (val - 1) * this.params.limit
      this.getModulesDetail()
    },

    listSearchEvn(val) {
      this.params.text = val
      this.getModulesDetail()
    },

    clearSearch() {
      this.params.hasOwnProperty('text') ? delete this.params.text : ''
      this.getModulesDetail()
    },
    done() {
      this.isSelect = false
      this.isHandle = 'move'
      this.checkAll()
      this.judgeCheckAll()
      //            this.$refs.BooksTable.toggleSelection()
    },
    clearCheckOpts() {
      this.allCheck = false
      this.manage = false
      this.bookArr = []
      this.bookArrId = []
      for (let item of this.booksData) {
        item.checked = false
      }
    },
    // ====================== sideBar 方法回调 ========================
    tableHandle(item) {
      let id = item.data.row.source_type === 4 ? 'ebook_id' : 'id'
      this.$router.push({
        name: 'bookDetails',
        query: { id: item.data.row[id], source: item.data.row.source_type }
      })
    },
    treeNodeClick(item) {
      this.done()
      if (!item.parent_id) return
      this.params.offset = 0
      this.clearCheckOpts()
      this.$router.push({
        name: 'list',
        query: { ...this.$route.query, id: item.id }
      })
    },
    addChildNode(item) {
      this.treeItem = item
      this.addPopupTitle = this.$t('alertMsg.addGroup')
      this.$store.commit('windowHandle', 'showAddBooksList')
    },
    refreshNode(item) {
      this.treeItem = item
      this.refreshTitle = this.$t('alertMsg.refreshGroup')
      this.$store.commit('windowHandle', 'showRefreshBooksList')
    },
    editorNode(item) {
      this.treeItem = item
      this.channelTitle = this.$t('content.books.editChannel')
      this.$store.commit('windowHandle', 'addRootNodeBooks')
    },
    delNode(item) {
      this.treeItem = item
      this.delType = 'treeNode'
      this.$store.commit('windowHandle', 'delPopup')
    },
    addRootNode() {
      this.treeItem = null
      this.channelTitle = this.$t('content.books.addChannel')
      this.$store.commit('windowHandle', 'addRootNodeBooks')
    },
    dragstart(node) {
      this.dragType = node.type === 1 ? 'parent' : 'children'
      this.dragItem = node
    },
    async drop(node) {
      let tempArr = null
      if (this.dragType === 'children') {
        if (
          !this.dragItem.parent_id ||
          !node.parent_id ||
          this.dragItem.parent_id !== node.parent_id
        )
          return this.elMsg(this.$t('alertMsg.sortErr2'), 'warning')
        // for (let item of this.channels) {
        //     if (item.id === node.parent_id) {
        //         tempArr = item.children.splice(item.children.indexOf(this.dragItem), 1)
        //         if (this.dragItem.ordinal >= node.ordinal) {
        //             item.children.splice(item.children.indexOf(node), 0, ...tempArr)
        //         } else {
        //             item.children.splice(item.children.indexOf(node) + 1, 0, ...tempArr)
        //         }
        //         tempArr = item.children
        //     }
        // }
      } else {
        if (this.dragItem.parent_id || node.parent_id)
          return this.elMsg(this.$t('alertMsg.sortErr2'), 'warning')
      }
      tempArr = {
        id1: this.dragItem.id,
        ordinal1: this.dragItem.ordinal,
        id2: node.id,
        ordinal2: node.ordinal
      }
      try {
        // await this.$http.bookListOrder(tempArr)
        await this.$http.bookChannelOrder(tempArr)
        this.getBookChannels()
      } catch (err) {
        this.elMsg(this.$t('alertMsg.sortFailure'), 'error')
      }
    },

    async changeTreeNodeChild(arr) {
      await this.$http.sortChannelsBook(arr)
    },
    // ====================== bookListHeader 方法回调 ========================
    editBookList() {
      this.addPopupTitle = this.$t('content.books.editGroup')
      this.$store.commit('windowHandle', 'showAddBooksList')
    },
    publish(data) {
      this.$store.commit('windowHandle', 'showPushChannel')
    },
    timing() {
      this.$store.commit('windowHandle', 'showDateTimePicker')
    },
    addBook() {
      this.$router.push({
        name: 'bookstack',
        query: { name: 'stack', from: this.$route.fullPath }
      })
      this.$store.dispatch('setSelectShow', true)
      this.$store.dispatch('setOverallShow', true)
      this.$store.dispatch('setHandleShow', 'handle')
    },
    manageBook(val, isHandle) {
      this.isSelect = val
      this.isHandle = isHandle
      this.manage = !this.manage
      if (this.manage) return
      this.clearCheckOpts()
    },
    importBook() {},
    // ====================== bookItem 方法回调 ========================
    checkBookDetail(item) {
      let id = item.source_type === 4 ? 'ebook_id' : 'id'
      this.$router.push({
        name: 'bookDetails',
        query: { id: item[id], source: item.source_type }
      })
    },
    delEvn(item) {
      this.delType = 'single'
      this.singleItem = item
      this.$store.commit('windowHandle', 'delPopup')
    },
    moveEvn(item) {
      this.singleBookId = []
      this.singleBookId.push(item.id)
      this.$store.commit('windowHandle', 'showAddBookList')
    },
    checkOptions(data) {
      if (!this.bookArr.length) {
        for (let item of data.books) {
          item.checked = false
        }
      } else {
        this.getArrID()
        for (let item of data.books) {
          item.checked = this.bookArrId.includes(item.id)
        }
      }
      this.booksData = data.books
      this.total = data.booksTotal
      this.judgeCheckAll()
    },
    getArrID() {
      this.bookArrId = []
      this.bookArrId = this.bookArr.map((item) => {
        return item.id
      })
    },
    filterEvn(data) {
      let { obj, key } = data
      if (key === 'status') {
        if (!obj[key].length || obj[key].length === 2) {
          delete this.params.status
        } else {
          this.params.status = obj[key][0]
        }
      }

      this.getModulesDetail()
    },
    selectEvn(book) {
      if (book.checked) {
        this.bookArr = [...this.bookArr, book]
      } else {
        this.bookArr = this.bookArr.filter((item) => {
          return item.id !== book.id
        })
      }
      this.judgeCheckAll()
    },
    checkAll(value) {
      if (value) {
        for (let item of this.booksData) {
          item.checked = true
        }
      } else {
        for (let item of this.booksData) {
          item.checked = false
        }
      }
      this.checkAllEvent()
    },
    checkAllEvent() {
      let data = this.booksData
      let ids = this.bookArr.map((item) => item.id)
      for (let i = 0; i < data.length; i++) {
        if (data[i].checked && !ids.includes(data[i].id)) {
          this.bookArr = [...this.bookArr, data[i]]
        } else if (!data[i].checked && ids.includes(data[i].id)) {
          this.bookArr = this.bookArr.filter((item) => {
            return item.id !== data[i].id
          })
        }
      }
    },
    judgeCheckAll() {
      if (!this.booksData.length) return
      let length = 0
      for (let item of this.booksData) {
        if (item.checked) {
          length++
        }
      }
      this.allCheck = this.booksData.length === length
    },
    choseprofrom(id) {
      this.flag = id
    },
    choseprofromBtn(id) {
      this.flagBtn = id
    }
  },
  watch: {
    $route(news, olds) {
      this.checkedRouteID()
    }
  },
  async mounted() {
    await this.getBookChannels()
    this.checkedRouteID()
  }
}
</script>

<style lang="scss">
.list-container {
  flex: 1;
  display: flex;
  overflow: hidden;
  padding: 20px;
  .list-card {
    display: flex;
    flex: 1;
    overflow: hidden;
    > .el-card__body {
      flex: 1;
      display: flex;
      overflow: hidden;
      .list-card-left {
        overflow: hidden;
        padding: 20px 0 0 10px;
        width: 250px;
        height: calc(100% - 20px);
        display: flex;
        border-right: 1px solid #ccc;
        flex-direction: column;
        .sideBar-tree-btn {
          padding: 10px;
          > button {
            width: calc(100% - 10px);
            margin-left: 0;
          }
        }
        .sideBar-node {
          width: 250px;
          height: 100%;
          overflow: hidden;
          .sideBar-node-wrap {
            height: 100%;
            overflow: auto;
            padding-right: 0 !important;
          }
        }
        > .stack-card-left-header {
          margin-right: 10px;
          padding: 0 5px 5px;
          border-bottom: 1px solid #ccc;
          > .stack-card-left-header-title {
            display: flex;
            cursor: pointer;
            justify-content: space-between;
            padding: 5px;
            border-radius: 2px;
            transition: all 0.2s linear;
            .el-input__inner {
              width: 100px;
            }
          }
        }
      }
      .list-card-right {
        flex: 1;
        display: flex;
        overflow: hidden;
        flex-direction: column;
        .list-card-sort {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin: 10px 20px;
          padding: 0 20px 10px;
          border-bottom: 1px solid $globalBorderColor;
          > .sort-handle {
            > span {
              cursor: pointer;
              margin-right: 20px;
            }
          }
          > .sort-search {
            display: flex;
            align-items: center;
            > span {
              margin-left: 20px;
            }
          }
        }
        > .stack-mgt-handle {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 10px;
          > .stack-mgt-search {
            display: flex;
            > i {
              margin-right: 10px;
            }
          }
        }
        > .stack-card-item {
          flex: 1;
          display: flex;
          overflow: hidden;
          flex-direction: column;
          > .stack-card-sort {
            > .sort-item:first-child {
              display: flex;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              height: 42px;
              padding: 0 20px;
              background: #f3f3f3;
              border-bottom: 1px solid #ccc;
              span {
                margin-right: 40px;
                font-weight: 400;
                font-style: normal;
                font-size: 12px;
                color: #666666;
              }
              span.secectBackground {
                color: #bf735b;
              }
            }
            .sort-item:last-child {
              display: flex;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              height: 42px;
              padding: 0 20px;
              background: #f3f3f3;
              span:first-child {
                margin-right: 0;
              }
              span {
                margin-right: 40px;
                font-weight: 400;
                font-style: normal;
                font-size: 12px;
                color: #666666;
              }
              span.secectBackground {
                color: #bf735b;
              }
            }
          }
        }
      }
    }
  }
}
</style>
